import type { Maybe, OlStatus } from '@modules/types/graphql';

import type { OlSubjectCreateArgs } from '@modules/types/graphql';

export type CreateSubjectFormValues = {
    courseId: string;
    name: string;
    text: string;
    status: Maybe<OlStatus>;
};

class CreateSubjectRequest {
    courseId: OlSubjectCreateArgs['courseId'];
    name: OlSubjectCreateArgs['name'];
    text: OlSubjectCreateArgs['text'];
    status: OlSubjectCreateArgs['status'];

    constructor(values: CreateSubjectFormValues) {
        this.courseId = values.courseId;
        this.name = values.name;
        this.text = values.text;
        this.status = values.status;
    }
}

export { CreateSubjectRequest };
